import * as siape from '@/api/siape'

const state = {
  dados: []
}

const getters = {}

const mutations = {
  SET (state, payload) {
    state.dados = payload
  }
}

const actions = {
  async get (context, registro) {
    let data = await siape.get(registro)
    let instancia = data.instancia
    if (instancia) {
      let item = {
        identificacao: 'consignado_siape',
        nome: 'Consignado SIAPE'
      }
      context.dispatch('pedido/setSiape', item, { root: true })
      context.commit('SET', instancia)
    } else {
      context.dispatch('pedido/setSiape', false, { root: true })
      context.commit('SET', false)
    }
    return []
  },
  async clear (context) {
    context.dispatch('pedido/setSiape', false, { root: true })
    context.commit('SET', false)
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/siape.js